import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

interface GoBackOptions {
  fallback?: string
}

export const useGoBack = (options?: GoBackOptions): (() => void) => {
  const fallbackRoute = options?.fallback ?? '/'
  const navigate = useNavigate()
  const { key } = useLocation()
  return useCallback(() => {
    if (key === 'default') {
      navigate(fallbackRoute, { replace: true })
    } else {
      navigate(-1)
    }
  }, [fallbackRoute, navigate, key])
}
